import { useState, useEffect, useCallback, useRef } from "react";

const useInfiniteScroll = (callback, hasMoreData) => {
  const [isFetching, setIsFetching] = useState(false);
  let ref = useRef();
  let element = ref?.current;

  const handleScroll = useCallback(async () => {
    if (element) {
      const { scrollTop, scrollHeight, clientHeight } = element;
      if (scrollTop + clientHeight !== scrollHeight || isFetching) return;
      setIsFetching(true);
      if (hasMoreData) await callback();
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);
    }
  }, [element, isFetching, hasMoreData, callback]);

  useEffect(() => {
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [element, handleScroll]);

  return { ref, isFetching };
};

export default useInfiniteScroll;
